import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterComponent, FooterLeftComponent, FooterRightComponent } from './footer.component';
export class FooterModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [FooterComponent, FooterLeftComponent, FooterRightComponent],
    declarations: [FooterComponent, FooterLeftComponent, FooterRightComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FooterModule_tsickle_Closure_declarations() {
/** @type {?} */
FooterModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FooterModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
